import { h, Host } from "@stencil/core";
/**
 * The `ch-grid-action-refresh` component represents a refresh button for a grid action bar.
 * @deprecated Use `ch-tabular-grid` component instead. Use `ch-tabular-grid-action-refresh` instead.
 */
export class ChGridActionRefresh {
    constructor() {
        this.disabled = undefined;
    }
    /**
     * Event emitted when the refresh button is clicked.
     */
    refreshClicked;
    pressedHandler(eventInfo) {
        if (!eventInfo.key || eventInfo.key === "Enter" || eventInfo.key === " ") {
            this.refreshClicked.emit();
            eventInfo.stopPropagation();
        }
    }
    render() {
        return h(Host, { key: '1efb67139b65c025bb7fe7c558208bb6cc3dfc14', role: "button", tabindex: "0", disabled: this.disabled });
    }
    static get is() { return "ch-grid-action-refresh"; }
    static get originalStyleUrls() {
        return {
            "$": ["ch-grid-action-refresh.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["ch-grid-action-refresh.css"]
        };
    }
    static get properties() {
        return {
            "disabled": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Indicates whether the refresh button is disabled or not."
                },
                "attribute": "disabled",
                "reflect": false
            }
        };
    }
    static get events() {
        return [{
                "method": "refreshClicked",
                "name": "refreshClicked",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Event emitted when the refresh button is clicked."
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }];
    }
    static get listeners() {
        return [{
                "name": "keydown",
                "method": "pressedHandler",
                "target": undefined,
                "capture": false,
                "passive": true
            }, {
                "name": "click",
                "method": "pressedHandler",
                "target": undefined,
                "capture": false,
                "passive": true
            }];
    }
}
